// Core
import React from "react";

// Components - Contrib
import { ListGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";

function Sidebar(props) {
	return (
		<nav id="subjectAreaNav" className="bg-light h-100">
			<h4 className="p-3">FAQs</h4>
			<hr className="bg-fourth" style={{ height: "4px" }} />
			<div className="p-2 mb-2" style={{ background: "var(--bs-gray-300)" }}>
				{props.data[0].Category_Name}
			</div>
			<ListGroup className="subjectAreaList">
				{props.data.map((item) => {
					return (
						<ListGroup.Item key={item.ID} className="text-primary border-0 bg-transparent p-0">
							<NavLink to={item.URL.replace("#/", "")} className="d-block py-2 px-4">
								{item.Site_Display_Name}
							</NavLink>
						</ListGroup.Item>
					);
				})}
				<ListGroup.Item className="text-primary border-0 bg-transparent p-0">
					<a href="https://olaw.nih.gov/covid-19.htm" className="d-block py-2 px-4">
						COVID-19 Pandemic Contingency Planning for Animal Care and Use Programs
					</a>
				</ListGroup.Item>
			</ListGroup>
		</nav>
	);
}

export default Sidebar;
